import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import AuthBackground from '../../../assets/images/AuthImage.jpg';
import { useParams } from "react-router-dom";
import Logo from '../../../assets/images/Logo.png';
import TextField from '../../../components/TextField/TextField';
import {
  HideGlobalLoading,
  ShowGlobalLoading,
} from '../../../redux/actions/UiActions';
import COLORS from '../../../theme/Colors';
import {
  MediumHeightDivider,
  SmallHeightDivider,
  StyledButton,
} from '../../../theme/Styles';
import {
  FormSchema,
} from './ResetPasswordConstants';
import {
  BodyText,
  FlexStartContainer,
  FooterContainer,
  Image,
  LeftPanelContainer,
  LinkText,
  LogoImage,
  RowContainer,
  TextError,
  TextFieldContainer,
  Title,
} from './styles/ResetPasswordStyles';
import { updatePassword } from '../../../api/ResetPassword';
function ResetPassword() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { authenticated } = useSelector((state) => state.authReducer);
  const { enqueueSnackbar } = useSnackbar();
  let { token } = useParams();

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      repeatNewPassword: "",
    },
    validationSchema: FormSchema,
    onSubmit: (values) => {
      onRequest(values);
    },
  });

  const onRequest = async (formData) => {
    try {
      dispatch(ShowGlobalLoading("Cargando"));
      const response = await updatePassword({
        token,
        password: formData.newPassword,
      });
      console.log(response)
      if (response.success) {
        enqueueSnackbar("La contraseña ha cambiando satisfactoriamente", {
          variant: "success",
        });
        history.push("/public");
      }
      dispatch(HideGlobalLoading());
    } catch (error) {
      // Check if the error has a response with a message
      if (error.response && error.response.data && error.response.data.msg) {
        enqueueSnackbar(error.response.data.msg, {
          variant: "error",
        });
      } else {
        enqueueSnackbar("Ha ocurrido un error. Por favor, inténtelo más tarde.", {
          variant: "error",
        });
      }

      dispatch(HideGlobalLoading());
    }
  };

  return (
    <RowContainer>
      <LeftPanelContainer>
        <LogoImage src={Logo} />
        <FlexStartContainer>
          <Title>Restablecer contraseña</Title>
          <SmallHeightDivider />
          <SmallHeightDivider />

          <TextFieldContainer>
            <TextField
              type='password'
              id='newPassword'
              placeholder='Nueva contraseña'
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
              helperText={formik.touched.newPassword && formik.errors.newPassword}
            />
          </TextFieldContainer>



          <TextFieldContainer>

            <TextField
              type='password'
              id='repeatNewPassword'
              placeholder='Repetir nueva contraseña'
              value={formik.values.repeatNewPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.repeatNewPassword && Boolean(formik.errors.repeatNewPassword)}
              helperText={formik.touched.repeatNewPassword && formik.errors.repeatNewPassword}
            />

          </TextFieldContainer>


          <MediumHeightDivider />
          <StyledButton onClick={() => formik.handleSubmit()}>
            Restablecer contraseña
          </StyledButton>
          <MediumHeightDivider />

          <LinkText
            to='/public/login'
            style={{
              color: COLORS.primary,
            }}
          >
            Regresar
          </LinkText>
          <FooterContainer>
            <BodyText>
              @{process.env.REACT_APP_CONFIG_YEAR} Centro de Exportación e Inversión de la República Dominicana. Todos los
              derechos reservados.
            </BodyText>
          </FooterContainer>
        </FlexStartContainer>
      </LeftPanelContainer>
      <Image
        style={{
          backgroundImage: `url(${AuthBackground})`,
        }}
      />
    </RowContainer>
  );
}

export default ResetPassword;
